<!-- src/NewsList.svelte -->
<script>
  import { onMount, onDestroy } from 'svelte';
  import axios from 'axios';
  import "./style.css"

  let articles = [];
  let initialArticles = [];
  let sources = [];
  let pageNumber = 1;
  const pageSize = 10; // Adjust this according to your API

  let filteredSources = []; // Array to store filtered sources
  let loading = false;

  async function fetchNews() {
    try { 
      loading = true;
      const response = await axios.get(`https://onlygoodnews.today/api/news?pagenumber=${pageNumber}`);
      const data = response.data;
      articles = [...articles, ...data]; // Append new articles to the existing list
      pageNumber++; // Increment page number for the next request
      loading = false;
      
    } catch (error) {
      loading = false;
      console.error('Error fet ching news:', error);
    }
  }

  async function fetchSources() {
    try {
      const response = await axios.get('https://onlygoodnews.today/api/sources/en');
      sources = response.data;
    } catch (error) {
      console.error('Error fetching sources:', error);
    }
  }

  onMount(async () => {
    loadPreferences();
    await fetchSources();
    await fetchNews();

    observer = new IntersectionObserver(handleIntersect, { rootMargin: '0px 0px 100% 0px' });
    observer.observe(document.querySelector('#loadMoreTrigger'));
  });

  // Load preferences from localStorage
  function loadPreferences() {
    const savedPreferences = localStorage.getItem('filteredSources');
    if (savedPreferences) {
      filteredSources = JSON.parse(savedPreferences);
    }
  }

  // Save preferences to localStorage
  function savePreferences() {
    localStorage.setItem('filteredSources', JSON.stringify(filteredSources));
  }

  // Intersection observer for infinite scroll
  let observer;
  function handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        fetchNews();
      }
    });
  }

  function trackClick(articleTitle) {
    gtag('event', 'click', {
      'event_category': 'News Link',
      'event_label': articleTitle
    });
  }

  
  // Disconnect the observer when the component unmounts
  onDestroy(() => {
    if (observer) {
      observer.disconnect();
    }
  });

  
  // Site logos configuration
  const siteLogos = {
    'wp.pl': 'wp.png',
    'onet.pl': 'onet.svg',
    'bbc.com': 'bbc.svg',
    'nytimes.com': 'nytime.svg',
    'time.com': 'time.svg',
    'yahoo.com': 'yahoo.svg',
    'cnn.com': 'cnn.svg',
  };

  function getSiteLogo(parentUrl) {
    for (const site in siteLogos) {
      if (parentUrl.includes(site)) {
        return siteLogos[site];
      }
    }
    return 'ogn.jpeg';
  }

  function filterBySource(sourceUrl) {
    if (filteredSources.includes(sourceUrl)) {
      filteredSources = filteredSources.filter(url => url !== sourceUrl);
    } else {
      filteredSources = [...filteredSources, sourceUrl];
    }
    savePreferences();
  }
  function saveConfiguration() {
    console.log('Filtered sources:', filteredSources);
  }                   
</script>

<style>

</style>

<div style="margin-top:20px;">
  <button id="filterButton" on:click={() => {
    const checkboxContainer = document.querySelector('#checkboxContainer');
    checkboxContainer.style.display = checkboxContainer.style.display === 'none' ? 'block' : 'none';
  }}>Filter Content</button>

  <div id="checkboxContainer" style="display: none; background-color: #f9f9f9; padding: 20px; border-radius: 10px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">


    <div class="filterContainer">
      <p style="font-weight: bold;">Source:</p>
      {#each sources as source}
        <label style="margin-bottom: 10px;">
          <input
            type="checkbox"
            class="filterCheckbox"
            value={source}
            on:change={() => filterBySource(source)}
            checked={filteredSources.includes(source)}
          >
          <span style="margin-left: 5px;">{source}</span>
        </label>
      {/each}
    </div>
      
      <div class="filterContainer" style="margin-top:10px;">
        <p style="font-weight: bold;">Genre: (coming soon)</p>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category7"><span style="margin-left: 5px;">Sport</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category8"><span style="margin-left: 5px;">Politics</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category9"><span style="margin-left: 5px;">Technology</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category10"><span style="margin-left: 5px;">Business</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category11"><span style="margin-left: 5px;">Health</span></label>
        <label style="margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category12"><span style="margin-left: 5px;">Science</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category13"><span style="margin-left: 5px;">Entertainment</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category14"><span style="margin-left: 5px;">Travel</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category15"><span style="margin-left: 5px;">Food</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category16"><span style="margin-left: 5px;">Fashion</span></label>
        <label style="margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category17"><span style="margin-left: 5px;">Lifestyle</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category18"><span style="margin-left: 5px;">Environment</span></label>
        <label style=" margin-bottom: 10px;"><input type="checkbox" class="filterCheckbox" value="category19"><span style="margin-left: 5px;">Education</span></label>
      </div>

    <button class="saveConfigurationButton" on:click={saveConfiguration}>Save Configuration(coming soon)</button>
  </div>
</div>

<ul class="cards">
  {#each articles as article}
    {#if !filteredSources.length || filteredSources.includes(article.parentUrl)}
      <li>
          <a href="{article.url}" class="card" on:click={() => trackClick(article.title)}>
              <img src="{article.imageUrl}" class="card__image" alt="" />
              <div class="card__overlay">
                  <div class="card__header">
                      <svg class="card__arc" xmlns="http://www.w3.org/2000/svg">
                          <path />
                      </svg>
                      <img class="card__thumb" src="/sites_logos/{getSiteLogo(article.parentUrl)}" alt="" />
                      <div class="card__header-text">
                          <h3 class="card__title">{article.title}</h3>
                          <span class="card__status">{article.parentUrl}</span>
                      </div>
                  </div>
                  <p class="card__description">{article.description}</p>
              </div>
          </a>
      </li>
    {/if}
  {/each}
</ul>
<div id="loadMoreTrigger" style="height: 10px;"></div>